// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","footer__link":"Footer_footer__link__YdY+h","footer__separator":"Footer_footer__separator__dz0j+"};